import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse, List } from 'antd';
import { OPTIMISE_ISSUES } from '../plannerConfig';
import { ProgressList } from '../components/WithSubNavigation/styles';
import baseActions from '../actions';

const mapStateToProps = state => ({
  [OPTIMISE_ISSUES]: state[OPTIMISE_ISSUES].data,
  loading: state[OPTIMISE_ISSUES].loading,
});

const mapDispatchToProps = {
  get: baseActions.get,
};

const ISSUE_CATEGORIES = [{
  key: 'errors',
  label: 'Optimisation Errors',
}, {
  key: 'warnings',
  label: 'Optimisation Warnings',
}];

const ErrorWarningCategory = ({
  dataSource,
  header,
  maxHeight,
  ...rest
}) => (
  <Collapse.Panel header={header} key={header} {...rest}>
    <ProgressList
      size="small"
      maxHeight={maxHeight}
      dataSource={dataSource}
      renderItem={msg => (
        <List.Item>
          {msg}
        </List.Item>
      )}
    />
  </Collapse.Panel>
);

class OptimisationErrorWarningList extends Component {
  componentDidMount() {
    const { get, jobId } = this.props;
    get([OPTIMISE_ISSUES], { routeParams: { jobId } });
  }

  render() {
    const { optimiseIssues } = this.props;
    return (
      <Collapse bordered={false} className="DCRPOptimiseIssues">
        {ISSUE_CATEGORIES.map(({ key, label }) => (
          <ErrorWarningCategory key={key} dataSource={optimiseIssues[key] || []} header={label} maxHeight="50%" />
        ))}
      </Collapse>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OptimisationErrorWarningList);
